import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ethereum': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M311.9 260.8l-151.9 92.8-152-92.8 152-260.8zM160 383.4l152-92.8-152 221.4-152-221.4z'
      }
    ]
  }
})
